import { AppState } from 'src/app/store'

export const userAuthenticatedState = (state: AppState) => state.users.user
export const isWidgetUserState = (state: AppState): boolean => state?.users.user?.is_widget
export const isProjectDeveloperUserState = (state: AppState): boolean => state?.users.user?.is_project_developer
export const isAdminUserState = (state: AppState): boolean => state?.users.user?.is_superuser
export const isPremiumCalculatorUserState = (state: AppState) => state?.users.user?.groups?.includes('prime calculator')
export const isForwardProducerSelector = (state: AppState) => state?.users.user?.groups?.includes('forward producers')
export const selectUser = (state: AppState) => state.users.user
export const userPersonalData = (state: AppState) => state.users.registerForm.personalData
export const userCredentials = (state: AppState) => state.users.registerForm.credentials
export const isRegisterComplete = (state: AppState) => state.users.registerUser.email !== null
export const registerBrokerageUserSelector = (state: AppState) => state.users.registerUser
export const userCompanyDetailsSelector = (state: AppState) => state.users.user.company_details
export const validateEmailSelector = (state: AppState) => state.users.validateEmail
export const changePasswordSelector = (state: AppState) => state.users.changePassword
export const userSubscriptionsSelector = (state: AppState) => state.users.userSubscriptions
export const userCanCreateProjectsSelector = (state: AppState): boolean => {
  const user = state.users.user
  return user?.is_business && Boolean(user?.company)
}
export const isAdminOrDeveloperState = (state: AppState): boolean => {
  const user = state?.users.user
  return user?.is_superuser || user?.is_project_developer
}
export const userIsApiPremiumSelector = (state: AppState): boolean => {
  const user = state.users?.user
  if (!user) return false
  const groups = user.groups
  return user.is_superuser || groups.includes('api-enterprise-plan') || groups.includes('api-business-plan')
}
